var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicerecord1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2594 35.5259C61.853 37.3336 62.8209 39.7079 62.8209 42.3079C62.8209 44.9092 61.853 47.2836 60.2568 49.0913",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9528 25.1104C72.672 29.336 75.6412 35.4745 75.6412 42.3078C75.6412 49.1411 72.6707 55.2821 67.9502 59.5065",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6919 83.3335L11.5381 83.3335V77.586C11.5381 73.0348 14.5227 69.036 18.8881 67.7437C22.974 66.5335 28.4714 65.3848 34.615 65.3848C40.6573 65.3848 46.1881 66.5527 50.3201 67.7745C54.6932 69.0668 57.6919 73.063 57.6919 77.6232L57.6919 83.3335Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7949 42.3078C21.7949 35.227 27.5347 29.4873 34.6154 29.4873C41.6962 29.4873 47.4359 35.227 47.4359 42.3078C47.4359 49.3886 41.6962 57.6924 34.6154 57.6924C27.5347 57.6924 21.7949 49.3886 21.7949 42.3078Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6458 14.814C83.4817 21.3986 88.4611 31.2717 88.4611 42.3076C88.4611 53.346 83.4791 63.2204 75.6406 69.805",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicerecord1);
export default __webpack_public_path__ + "static/media/Voice record 1.7b586a99a562cfdfb88e8dba9a6f3c5b.svg";
export { ForwardRef as ReactComponent };